import { render } from "./About.vue?vue&type=template&id=039c5b43&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=039c5b43&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039c5b43"],['__file',"src/views/About.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "039c5b43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('039c5b43', __exports__)) {
    api.reload('039c5b43', __exports__)
  }
  
  module.hot.accept("./About.vue?vue&type=template&id=039c5b43&scoped=true", () => {
    api.rerender('039c5b43', render)
  })

}


export default __exports__